import { catchError } from 'rxjs/operators';

export const catcher = (fn: (error: any) => void) =>
  catchError((error, stream) => {
    fn(error);
    return stream;
  });
